<template>
  <v-container>
    <v-layout row fluid>
      <v-flex xs12  >
        <v-card>
          <v-toolbar class="primary">
            <v-toolbar-title class="white--text">Reporte Ventas</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-layout row wrap>
              <v-flex sm1 mr-1>
                <v-select
                  v-bind:items="rutas"
                  v-model="ruta"
                  itemText="nombre"
                  @change="filtrarruta($event)"
                  :value.sync="ruta"
                  label="Rutas"
                  single-line
                  bottom
                >
              </v-select>
              </v-flex>
              <v-flex sm2 mr-1>
                <v-select
                  v-bind:items="usuarios"
                  v-model="usuario"
                  itemText="username"
                  @change="filtrarusuario($event)"
                  :value.sync="usuario"
                  label="Usuario"
                  multiple
                  single-line
                  bottom
                >
              </v-select>
              </v-flex>
               <v-flex sm1 xs12>
                <v-dialog
                    persistent
                    v-model="menu"
                    lazy
                    full-width
                  >
                    <v-text-field
                      slot="activator"
                      label="Desde"
                      v-model="fechainicio"
                      prepend-icon="event"
                      readonly
                    ></v-text-field>
                    <v-date-picker v-model="fechainicio" scrollable>
                      <template slot-scope="{ save, cancel }">
                        <v-card-actions>
                          <v-btn flat primary @click.native="cancel()">Cancelar</v-btn>
                          <v-btn flat primary @click.native="save(), filtrarfechainicio()">Aceptar</v-btn>
                        </v-card-actions>
                      </template>
                    </v-date-picker>
                  </v-dialog>
              </v-flex>
              <v-flex xs8 sm1>
                <v-text-field
                  label="hora"
                  v-model="horainicio"
                ></v-text-field>
              </v-flex>
               <v-flex sm2 xs12>
                <v-dialog
                    persistent
                    v-model="menu2"
                    lazy
                    full-width
                  >
                    <v-text-field
                      slot="activator"
                      label="Hasta"
                      v-model="fechafin"
                      prepend-icon="event"
                      readonly
                    ></v-text-field>

                    <v-date-picker v-model="fechafin" scrollable >
                      <template slot-scope="{ save, cancel }">
                        <v-card-actions>
                          <v-btn flat primary @click.native="cancel()">Cancelar</v-btn>
                          <v-btn flat primary @click.native="save(), filtrarfechafin()">Aceptar</v-btn>
                        </v-card-actions>
                      </template>
                    </v-date-picker>
                  </v-dialog>
              </v-flex>
              <v-flex xs8 sm1>
                <v-text-field
                  label="hora"
                  v-model="horafin"
                ></v-text-field>
              </v-flex>
              <v-flex sm1 ml-2>
                <v-text-field type="number"  label="Extra" v-model="extra">
                </v-text-field>
              </v-flex>
              <v-flex sm2 ml-2>
                <v-text-field label="Comentario" v-model="comentario">
                </v-text-field>
              </v-flex>
               <v-flex sm2 xs12 v-if="tipo=='admin' || tipo=='secretaria' || tipo=='vendedor'">
                  <v-btn v-bind:disabled="disabled" flat @click="generar">
                    <v-icon>save</v-icon>
                  </v-btn>
               </v-flex>
              <v-flex sm2 xs12 v-if="tipo=='admin' || tipo=='secretaria' || tipo=='vendedor'">
                  <v-btn v-bind:disabled="disabled" flat @click="generartabulacion">
                    Tabulación <v-icon>save</v-icon>
                  </v-btn>
               </v-flex>
              <v-flex sm2 xs12 v-if="tipo=='admin' || tipo=='secretaria' || tipo=='vendedor'">
                  <v-btn v-bind:disabled="disabled" flat @click="generarcomentarios">
                    Comentarios <v-icon>save</v-icon>
                  </v-btn>
               </v-flex>
              <v-flex sm2 xs12 v-if="tipo=='admin' || tipo=='secretaria' || tipo=='vendedor'">
                  <v-btn v-bind:disabled="disabled" flat @click="obteneridsfactura" class="red--text">
                    Factura Electrónica <v-icon>save</v-icon>
                  </v-btn>
               </v-flex>
              <v-flex sm2 xs12 v-if="tipo=='admin' || tipo=='secretaria' || tipo=='vendedor'">
                  <v-btn v-bind:disabled="disabled" flat @click="generar('entregado')" class="red--text">
                    No tocar<v-icon>check</v-icon>
                  </v-btn>
               </v-flex>
               <v-flex sm2 xs12 v-if="tipo=='admin' || tipo=='secretaria' || tipo=='vendedor'">
                  <v-btn flat @click="generarexcel" class="green--text">
                    excel<v-icon>find_in_page</v-icon>
                  </v-btn>
               </v-flex>
              <v-flex sm2 xs12 v-if="tipo=='admin' || tipo=='secretaria' || tipo=='vendedor'">
                  <v-btn color="primary"
                         class="primary" v-on:click.native="dialogbusqueda = true"
                         @click="focusbusqueda"
                  >Re Imprimir</v-btn>
               </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        <v-dialog v-model="dialogbusqueda" lazy absolute persistent>
      <v-card>
        <v-card-title>
          <div class="headline">Confirmación Administrador</div>
           <v-flex sm12>
             <v-text-field label="contraseña" type="password"
                           v-model="confirmacion"
                           autofocus ref="searchprodi"
                           @keyup.enter="generar('entregado'), confirmacion, nombre_tabulacion"
             >
          </v-text-field>

           </v-flex>
          <v-flex sm12>
             <v-text-field label="Nombre de la tabulación"
                           v-model="nombre_tabulacion"
                           autofocus ref="searchprodi"
                           @keyup.enter="generar('entregado'), confirmacion, nombre_tabulacion"
             >
          </v-text-field>

           </v-flex>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-bind:tabindex="-1" class="green--text darken-1" flat="flat"
                 @click.native="dialogbusqueda = false, confirmacion='', nombre_tabulacion=''">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
      </v-flex>
    </v-layout>
    <v-layout>
    </v-layout>
  </v-container>
</template>

<script>
  import {
  baseurl
} from '../plugins/urlsbackend'
  export default {
    created: function () {
      this.$store.dispatch('getrutas')
      this.$store.dispatch('getusuarios')
    },
    data () {
      return {
        menu: false,
        menu2: false,
        fechainicio: '',
        fechafin: '',
        ruta: '',
        usuario: [],
        extra: '',
        comentario: '',
        serie: '1',
        inicio: '1',
        dialogbusqueda: false,
        confirmacion: null,
        nombre_tabulacion: null,
        horainicio: '',
        horafin: '',
        disable: false
      }
    },
    methods: {
      filtrarusuario: function (usuario) {
        console.log(this.usuario)
        this.ruta = ''
      },
      filtrarruta: function (ruta) {
        this.usuario = []
      },
      filtrarfechafin: function () {
        console.log(this.fechafin)
      },
      filtrarfechainicio: function () {
        console.log(this.fechainicio)
      },
      focusbusqueda () {
        let vm = this
        setTimeout(function () {
          vm.$refs.searchprodi.focus()
        }, 100)
      },
      generar: function (entregado = null) {
        var idusuarios = ''
        this.usuario.forEach(llenarusuarios)
        function llenarusuarios (element) {
          idusuarios = idusuarios + '' + element['id'].toString() + ','
        }
        if (this.nombre_tabulacion != null && (this.confirmacion == null || this.confirmacion === '')) {
          alert('ingrese la contraseña')
        }
        if ((this.ruta !== '' | this.usuario !== []) && this.fechainicio && this.fechafin) {
          this.disable = 1
          alert('generando reporte pdf, cierre esta ventana y  espere un momento')
          this.$http.get(baseurl + '/apicatalogos/pdfgeneration',
            {params: {
              ruta: this.ruta.nombre,
              usuario: idusuarios,
              extra: this.extra,
              comentario: this.comentario,
              fechaminima: this.fechainicio,
              fechamaxima: this.fechafin,
              serie: this.serie,
              inicio: this.inicio,
              confirmacion: this.confirmacion,
              nombre_tabulacion: this.nombre_tabulacion,
              horamaxima: this.horafin,
              horaminima: this.horainicio,
              entregado: entregado
            },
              headers: {'Authorization': 'Token ' + localStorage.getItem('token')},
              responseType: 'arraybuffer'}).then(response => {
                if (response.status === 200) {
                  let blob = new Blob([response.body], {type: 'application/pdf'})
                  let link = document.createElement('a')
                  link.href = window.URL.createObjectURL(blob)
                  window.open(link.href)
                  this.disable = 0
                } else {
                  alert('Este número de taulación ya existe por favor agregue extra')
                  alert('Este número de taulación ya existe por favor agregue extra' + response.status)
                  this.disable = 0
                }
              }, response2 => {
                if (response2.status === 403) {
                  alert('contraseña incorrecta')
                } else if (response2.status === 500) {
                  alert('A ocurrido un error al generar la tabulación')
                } else {
                  alert('Este número de taulación ya existe por favor agregue extra')
                }
              }, this.disable = 0)
        }
      },
      generartabulacion: function (entregado = null) {
        var idusuarios = ''
        this.usuario.forEach(llenarusuarios)
        function llenarusuarios (element) {
          idusuarios = idusuarios + '' + element['id'].toString() + ','
        }
        if ((this.ruta !== '' | this.usuario !== []) && this.fechainicio && this.fechafin) {
          this.disable = 1
          alert('generando reporte pdf, cierre esta ventana y  espere un momento')
          this.$http.get(baseurl + '/apicatalogos/pdftabulacion',
            {params: {
              ruta: this.ruta.nombre,
              usuario: idusuarios,
              extra: this.extra,
              comentario: this.comentario,
              fechaminima: this.fechainicio,
              fechamaxima: this.fechafin,
              serie: this.serie,
              inicio: this.inicio,
              confirmacion: this.confirmacion,
              horamaxima: this.horafin,
              horaminima: this.horainicio,
              entregado: entregado
            },
              headers: {'Authorization': 'Token ' + localStorage.getItem('token')},
              responseType: 'arraybuffer'}).then(response => {
                let blob = new Blob([response.body], {type: 'application/pdf'})
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                window.open(link.href)
                this.disable = 0
              })
        }
      },
      generarcomentarios: function (entregado = null) {
        var idusuarios = ''
        this.usuario.forEach(llenarusuarios)
        function llenarusuarios (element) {
          idusuarios = idusuarios + '' + element['id'].toString() + ','
        }
        if ((this.ruta !== '' | this.usuario !== []) && this.fechainicio && this.fechafin) {
          this.disable = 1
          alert('generando reporte pdf, cierre esta ventana y  espere un momento')
          this.$http.get(baseurl + '/apicatalogos/pdfcomentarios',
            {params: {
              ruta: this.ruta.nombre,
              usuario: idusuarios,
              extra: this.extra,
              fechaminima: this.fechainicio,
              fechamaxima: this.fechafin,
              serie: this.serie,
              inicio: this.inicio,
              confirmacion: this.confirmacion,
              horamaxima: this.horafin,
              horaminima: this.horainicio,
              entregado: entregado
            },
              headers: {'Authorization': 'Token ' + localStorage.getItem('token')},
              responseType: 'arraybuffer'}).then(response => {
                let blob = new Blob([response.body], {type: 'application/ms-excel'})
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                window.open(link.href)
                this.disable = 0
              })
        }
      },
      obteneridsfactura: function (entregado = null) {
        var idusuarios = ''
        this.usuario.forEach(llenarusuarios)
        function llenarusuarios (element) {
          idusuarios = idusuarios + '' + element['id'].toString() + ','
        }
        if ((this.ruta !== '' | this.usuario !== []) && this.fechainicio && this.fechafin) {
          this.disable = 1
          alert('generando reporte pdf, cierre esta ventana y  espere un momento')
          this.$http.get(baseurl + '/apicatalogos/listadofactura',
            {params: {
              ruta: this.ruta.nombre,
              usuario: idusuarios,
              extra: this.extra,
              fechaminima: this.fechainicio,
              fechamaxima: this.fechafin,
              serie: this.serie,
              inicio: this.inicio,
              confirmacion: this.confirmacion,
              horamaxima: this.horafin,
              horaminima: this.horainicio,
              entregado: entregado
            },
              headers: {'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
                this.$store.commit('setidsfactura', response.body)
                let ids = this.$store.getters.getidfactura
                this.$store.dispatch('imprimirfacturaelectronica2', {factura: {id: ids.pop()}})
                this.$store.commit('setidsfactura', ids)
                this.disable = 0
              })
        }
      },
      generarexcel: function () {
        var idusuarios = ''
        this.usuario.forEach(llenarusuarios)
        function llenarusuarios (element) {
          idusuarios = idusuarios + '' + element['id'].toString() + ','
        }
        if ((this.ruta !== '' | this.usuario !== []) && this.fechainicio && this.fechafin) {
          alert('generando reporte de excel por favor cierre esta ventana y espere un momento')
          this.$http.get(baseurl + '/apicatalogos/xlsgeneration',
            {params: {
              ruta: this.ruta.nombre,
              extra: this.extra,
              fechaminima: this.fechainicio,
              fechamaxima: this.fechafin,
              serie: this.serie,
              inicio: this.inicio,
              confirmacion: this.confirmacion,
              horamaxima: this.horafin,
              horaminima: this.horainicio,
              usuario: idusuarios
            },
              headers: {'Authorization': 'Token ' + localStorage.getItem('token')},
              responseType: 'arraybuffer'}).then(response => {
                let blob = new Blob([response.body], {type: 'application/ms-excel'})
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                window.open(link.href)
              })
        }
      }
    },
    computed: {
      rutas: function () {
        return this.$store.getters.rutas
      },
      usuarios: function () {
        return this.$store.getters.usuarios
      },
      disabled: function () {
        if (this.disable) {
          return true
        }
        return false
      },
      tipo: function () {
        return this.$store.getters.gettipo
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Reporte.vue?49c5b9d0